module.exports = __webpack_public_path__ + "static/fonts/NanumGothic_seR.9b4e63e.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/NanumGothic_seR.ttf
// module id = sW6Q
// module chunks = 241